(function () {
  'use strict';

  angular.module('soBiLog').provider('soBiLogger', soBiLoggerProvider);

  function soBiLoggerProvider() {
    this.$get = [
      'clientConfig',
      'domBiLogger',
      function (clientConfig, domBiLogger) {
        return new SoBiLogger(domBiLogger, clientConfig.mandatoryBiFields || {});
      },
    ];
  }

  function SoBiLogger(biLogger, biFields) {
    this.log = function (evid, params) {
      biLogger.log(evid, _.assign({}, params || {}, biFields || {}));
    };
  }
})();
